import BookOfAuthorItem from "./book-of-author.component";

export default BookOfAuthorItem;
